import { useState } from 'react';
import axios from 'axios';
import { PLATFORM_KEYS } from '../constants';

const extractUrlParts = (url) => {
    try {
        const parsedUrl = new URL(url);
        const hostParts = parsedUrl.hostname.split('.');
        return {
            fullUrl: url,
            fullHostname: parsedUrl.hostname,
            subdomain: hostParts.length > 2 ? hostParts[0] : null,
            domain: hostParts.length > 2 ? hostParts[1] : hostParts[0],
            tld: hostParts.slice(-2).join('.'),
        };
    } catch (error) {
        console.error("Invalid URL:", url);
        return null;
    }
};

const useGameFlexUrls = (selectedServer) => {
    const [sessionToken, setSessionToken] = useState("");
    const [error, setError] = useState("");

    const platformKeyDetails = PLATFORM_KEYS.map((platform) => ({
        ...platform,
        ...extractUrlParts(platform.url),
    }));

    const getFullHostname = (key) => {
        const platform = platformKeyDetails.find((p) => p.key === key);
        return platform ? platform.fullHostname : null;
    };

    const temphost = getFullHostname(selectedServer.platformKey);
    const gameId = selectedServer?.game?.GameflexGameID || selectedServer.demo;
    const brandId = selectedServer.brand ? selectedServer.brand.split('-')[0].trim() : "undefined";
    const deskMob = selectedServer?.mobDesk;

    const gameflexSessionURL = `${selectedServer.rootUrl}/api/json/test/session/createSessionForAccount?platformkey=${selectedServer.platformKey}&operatorcode=${selectedServer.operatorCode}&accountid=${selectedServer.accountId}&languagecode=en&gameproviderid=51&gameid=${gameId}&channelid=${deskMob}`;

    //const gameflexSessionURL = `https://gameflex-p000.iforium.com/gamelaunch/api/json/test/session/createSessionForAccount?platformkey=P009&operatorcode=DGC&accountid=${selectedServer.accountId}&languagecode=en&gameproviderid=51&gameid=${gameId}&channelid=desktop`;
    const gameFlexReal = `https://gameflex-p000.iforium.com/gamelaunch/v1/controllers/desktop/session-ticket/?platformkey=P009&operatorcode=DGC&brandid=143&languagecode=en&channelid=Desktop&gameid=${gameId}&mode=Real&sessionticket=${sessionToken}&currencycode=USD&domainoriginurl=https%3A%2F%2Fgameflex-p000.iforium.com&options=%7B%22customProperties%22%3A%7B%7D%2C%22gameLaunchApiParameters%22%3A%7B%22TimeZone%22%3A%22-5%22%2C%22PromotionTermsAndConditionsUrl%22%3A%22https%3A%2F%2Fgameflex-p000.iforium.com%2Fgamelaunch%2Ftest%2Fgameflex%22%2C%22ExitUrl%22%3A%22https%3A%2F%2Fgameflex-p000.iforium.com%2Fgamelaunch%2Fv1%2Fplugins%2FcloseGame.html%3Fd%3Dhttps%253A%252F%252Fgameflex-p000.iforium.com%26r%3Dexit-url%26gul%3Dfalse%26l%3Dundefined%22%2C%22GameflexDomainOriginUrl%22%3A%22https%3A%2F%2Fgameflex-p000.iforium.com%22%7D%2C%22rootUrl%22%3A%22https%3A%2F%2Fgameflex-p000.iforium.com%2Fgamelaunch%2Fv1%2F%22%2C%22gameLaunchType%22%3A1%2C%22launchLocation%22%3A%7B%22deviceChannel%22%3A%7B%22id%22%3A%22web%22%7D%2C%22productChannel%22%3A%7B%22id%22%3A%22casino%22%7D%2C%22categoryPath%22%3A%22testpage%22%2C%22position%22%3A1%7D%7D`;
    const gameFlexDemo = `https://gameflex-p000.iforium.com/gamelaunch/v1/controllers/desktop/guest/?platformkey=P009&operatorcode=DGC&brandid=143&languagecode=en&channelid=Desktop&gameid=${gameId}&mode=Fun&currencycode=USD&domainoriginurl=https%3A%2F%2Fgameflex-p000.iforium.com&options=%7B%22customProperties%22%3A%7B%7D%2C%22gameLaunchApiParameters%22%3A%7B%22TimeZone%22%3A%22-5%22%2C%22PromotionTermsAndConditionsUrl%22%3A%22https%3A%2F%2Fgameflex-p000.iforium.com%2Fgamelaunch%2Ftest%2Fgameflex%22%2C%22ExitUrl%22%3A%22https%3A%2F%2Fgameflex-p000.iforium.com%2Fgamelaunch%2Fv1%2Fplugins%2FcloseGame.html%3Fd%3Dhttps%253A%252F%252Fgameflex-p000.iforium.com%26r%3Dexit-url%26gul%3Dfalse%26l%3Dundefined%22%2C%22GameflexDomainOriginUrl%22%3A%22https%3A%2F%2Fgameflex-p000.iforium.com%22%7D%2C%22rootUrl%22%3A%22https%3A%2F%2Fgameflex-p000.iforium.com%2Fgamelaunch%2Fv1%2F%22%2C%22gameLaunchType%22%3A1%2C%22launchLocation%22%3A%7B%22deviceChannel%22%3A%7B%22id%22%3A%22web%22%7D%2C%22productChannel%22%3A%7B%22id%22%3A%22casino%22%7D%2C%22categoryPath%22%3A%22testpage%22%2C%22position%22%3A1%7D%7D`;


    // https://gameflex-p000.iforium.com/gamelaunch/api/json/test/session/createSessionForAccount?platformkey=P009&operatorcode=DGC&accountid=&languagecode=en&gameproviderid=51&gameid=30645&channelid=desktop
    const generateLaunchUrl = (mode) => {
        const baseOptions = {
            customProperties: {},
            gameLaunchApiParameters: {
                TimeZone: "-5",
                PromotionTermsAndConditionsUrl: `https://${temphost}/gamelaunch/test/gameflex`,
                ExitUrl: `https://${temphost}/gamelaunch/v1/plugins/closeGame.html?d=https%253A%252F%252F${temphost}&r=exit-url&gul=false&l=undefined`,
                GameflexDomainOriginUrl: `https://${temphost}`
            },
            rootUrl: `https://${temphost}/gamelaunch/v1/`,
            gameLaunchType: 1,
            launchLocation: {
                deviceChannel: { id: "web" },
                productChannel: { id: "casino" },
                categoryPath: "testpage",
                position: 1
            }
        };

        return `${selectedServer.rootUrl}/v1/controllers/desktop/${mode === 'Real' ? 'session-ticket' : 'guest'}/?platformkey=${selectedServer.platformKey}&operatorcode=${selectedServer.operatorCode}&brandid=${brandId}&languagecode=en&channelid=${deskMob}&gameid=${gameId}&mode=${mode}&${mode === 'Real' ? `sessionticket=${sessionToken}&` : ''}currencycode=USD&domainoriginurl=https%3A%2F%2F${temphost}&options=${encodeURIComponent(JSON.stringify(baseOptions))}`;
    };

    const authenticate = async () => {
        try {
            setError("");
            const response = await axios.get(gameflexSessionURL);
            if (response.data.Status === "Success") {
                setSessionToken(response.data.Result.SessionTicket);
                setError("Successfully Generated Session Ticket.");
            } else {
                setError("Authentication failed. Please check your Account ID.");
            }
        } catch (err) {
            console.error("Error during authentication:", err);
            setError("Failed to authenticate. Please check your Account ID.");
        }
    };

    return {
        sessionToken,
        error,
        authenticate,
        gameFlexReal: generateLaunchUrl('Real'),
        gameFlexDemo: generateLaunchUrl('Fun'),
    };
};

export default useGameFlexUrls;